/* eslint-disable react/prop-types */
import React from "react";
import DatePicker from "react-datepicker";
import { getMonth, getYear } from "date-fns";
import range from "lodash/range";
import "react-datepicker/dist/react-datepicker.css";
import "../../../../css/Recruitment/FormField.css";
import { getIsApproved } from "../Utils/UidListener";
import { addUidListener } from "../Utils/UidListener";
import { useState, useEffect } from "react";

export default function UseDatepicker({
  placeholderText,
  value,
  onChange,
  err,
  dateFormat,

  readOnly,
}) {
  const years = range(1890, getYear(new Date()) + 1, 1);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const [isApproved, setIsApproved] = useState(getIsApproved());
  useEffect(() => {
    const unsubscribe = addUidListener((uid, approved) => {
      setIsApproved(approved);
      // console.log("Approved status is: ", approved);
    });
    return () => unsubscribe();
  }, []);
  return (
    <div className="input-wrapper">
      <span className={`fake-placeholder ${value ? "has-value" : ""} `}>
        {value ? placeholderText : ""}
      </span>
      <div className="react-datepicker-popper">
        <DatePicker
          // dateFormat="MM/yyyy"
          placeholderText={placeholderText}
          closeOnScroll={true}
          isClearable={
            isApproved === true ? false : readOnly === true ? false : true
          }
          readOnly={isApproved === true ? true : readOnly}
          dateFormat={dateFormat}
          showMonthYearPicker={dateFormat === "MMMM yyyy"}
          showDateSelector={dateFormat === "DD MMMM yyyy"}
          className={value ? "has-value" : err ? "error" : ""} // Add class if value is present
          error={err}
          renderCustomHeader={({ date, changeYear, changeMonth }) => (
            <div >
              <div>
                <select
                  className="custom-select-style"
                  value={getYear(date)}
                  onChange={({ target: { value } }) => changeYear(value)}
                >
                  {years.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>

                <select
                  className="custom-select-style"
                  value={months[getMonth(date)]}
                  onChange={({ target: { value } }) =>
                    changeMonth(months.indexOf(value))
                  }
                >
                  {months.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
          selected={value} // Controlled by parent
          onChange={onChange} // Pass the date back to parent
        />
      </div>
    </div>
  );
}
